module.exports = __webpack_public_path__ + "static/media/vw-transporter1.88c7a8ec.webp";